
import { takeLatest, call, put, select } from 'redux-saga/effects';
import { hotelStaffActionTypes } from './hotelStaffTypes';
import { hotelStaffApiResponseError, hotelStaffApiResponseSuccess } from './hotelStaffActions'
import { showErrorNotification, showSuccessNotification } from "../../helpers/NotificationContext";
import { insertStaffHotelApi, getAllStaffHotelApi, deleteStaffHotelApi } from 'src/api/hotelStaff';



function* insertHotelStaffSaga(action: any) {
    try {
        console.log("[insertHotelStaffSaga] action.payload", action.payload);

        const payload = action.payload;
        console.log("insertHotelStaffSaga sending payload to api:", payload);
        const response = yield call(insertStaffHotelApi, payload);
        console.log("Backend response from insertHotelStaffSaga: ", response);
        yield put(hotelStaffApiResponseSuccess(hotelStaffActionTypes.INSERT_HOTEL_STAFF, response));
        showSuccessNotification(`🚀 Details fetched successfully!`);

    } catch (error: any) {
        console.error(" insertHotelStaffSaga Saga error ", error.message);
        yield put(hotelStaffApiResponseError(hotelStaffActionTypes.INSERT_HOTEL_STAFF, error.message));
        showErrorNotification("Execution failed: " + error.message);
    }
}




function* getAllHotelStaffSaga(action: any) {
    try {
        console.log("[getAllHotelStaffSaga] action.payload", action.payload);

        const payload = action.payload;
        console.log("getAllHotelStaffSaga sending payload to api:", payload);
        const response = yield call(getAllStaffHotelApi);
        console.log("Backend response from getAllHotelStaffSaga: ", response);
        yield put(hotelStaffApiResponseSuccess(hotelStaffActionTypes.GET_ALL_STAFF, response));
        showSuccessNotification(`🚀 Details fetched successfully!`);

    } catch (error: any) {
        console.error(" getAllHotelStaffSaga Saga error ", error.message);
        yield put(hotelStaffApiResponseError(hotelStaffActionTypes.GET_ALL_STAFF, error.message));
        showErrorNotification("Execution failed: " + error.message);
    }
}



function* deleteHotelStaffSaga(action: any) {
    try {
        console.log("[deleteHotelStaffSaga] action.payload", action.payload);

        const payload = action.payload;
        console.log("deleteHotelStaffSaga sending payload to api:", payload);
        const response = yield call(deleteStaffHotelApi, payload);
        console.log("Backend response from deleteHotelStaffSaga: ", response);
        yield put(hotelStaffApiResponseSuccess(hotelStaffActionTypes.DELETE_STAFF, response));
        showSuccessNotification(`🚀 Details fetched successfully!`);

    } catch (error: any) {
        console.error(" deleteHotelStaffSaga Saga error ", error.message);
        yield put(hotelStaffApiResponseError(hotelStaffActionTypes.DELETE_STAFF, error.message));
        showErrorNotification("Execution failed: " + error.message);
    }
}


export default function* hotelStaffSaga() {
    yield takeLatest(hotelStaffActionTypes.INSERT_HOTEL_STAFF, insertHotelStaffSaga);
    yield takeLatest(hotelStaffActionTypes.GET_ALL_STAFF, getAllHotelStaffSaga);
    yield takeLatest(hotelStaffActionTypes.DELETE_STAFF, deleteHotelStaffSaga);


}
